export const DATE_FORMAT = 'MM/dd/yyyy' // 02/23/2020
export const TIMESTAMP_FORMAT = 'yyyy_MM_dd_hh_mm_ss' // 2020_02_23_10_45_35
export const DATE_TIME_FORMAT = 'MM/dd/yyyy hh:mm:ss a' // 02/23/2020 10:45:35 PM
